<template>
  <div>
    <Header
      :disabled="disabled"
      @openDetailDialog="openDetailDialog"
      @batchDel="batchDel"
      ref="tableHeader"
    />
    <Main
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      :tableHeight="tableHeight"
      @reload="getData"
      @batchDel="submitDel"
      @openDetailDialog="openDetailDialog"
      ref="tableMain"
    />
    <GoodsMaterialDetailDialog
      :disabled="techGoodsSpecDetailDialogOptions.disabled"
      :visible="techGoodsSpecDetailDialogOptions.visible"
      :title="techGoodsSpecDetailDialogOptions.title"
      :techGoodsMaterialCode="techGoodsSpecDetailDialogOptions.code"
      @reload="getData()"
      @close="() => (techGoodsSpecDetailDialogOptions.visible = false)"
      :productLine="productLine"
      :techGoodsSpecCode="techGoodsSpecCode"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
import GoodsMaterialDetailDialog from '../components/detail/dialog.vue'
export default {
  components: { Main, Header, GoodsMaterialDetailDialog },
  props: {
    disabled: { type: Boolean, default: false },
    productLine: { type: String, default: '' },
    techGoodsSpecCode: { type: String, default: '' },
    tableHeight: { type: Number, default: 200 },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      techGoodsSpecDetailDialogOptions: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.techGoodsSpecCode) return
      this.loading = true
      this.$api
        .techGoodsMaterialListApi({
          techGoodsSpecCode: this.techGoodsSpecCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
    openDetailDialog({ type, code = '' }) {
      const types = {
        add:
          this.$l('dialog_title_add_product_material_information') ||
          '添加产品辅料信息',
        edit:
          this.$l('dialog_title_edit_product_material_information') ||
          '编辑产品辅料信息',
        detail:
          this.$l('dialog_title_product_material_information_detail') ||
          '产品辅料详情',
      }
      this.techGoodsSpecDetailDialogOptions = {
        visible: true,
        title: types[type],
        code,
        disabled: type === 'detail',
      }
    },
    batchDel() {
      const listCode = this.$refs.tableMain.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.techGoodsMaterialDelApi({ listCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.getData()
        })
      })
    },
  },
}
</script>
